module.exports = __webpack_public_path__ + "static/media/chart.f691df83.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/splash-page-images/chart.png
// module id = 345
// module chunks = 0